module.exports = __webpack_public_path__ + "static/media/CT_2019_30445A.31a2fef2.png";